<template>
    <div class="start-page-component-container">
        <div class="component-wrapper">
            <div class="start-page-container">
                <div class="fit20-logo-container">
                    <img src="../../assets/imgs/fit20_logo.png" alt="fit20_logo">
                </div>
                <div class="start-page-btns-container">
                    <div class="btns-wrapper">
                        <div class="login-btn-container" @click="displayLoginPage">
                            <!-- <div class="login-btn btn">login</div> -->
                            <div class="login-btn btn">{{ $t("login") }}</div>
                        </div>
                        <div class="try-free-experience-container">
                            <!-- <p>Nog geen lid?</p> -->
                            <p>{{ $t("not_member_yet") }}</p>
                            <!-- <p class="free-ecperience-btn" @click="displaySelectCountryPage">Ervaar fit20 gratis!</p> -->
                            <p class="free-ecperience-btn" @click="displaySelectCountryPage">
                                {{ $t("experience_fit20_free") }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StartPage',
    props: {

    },
    // data() {
    //     return {

    //     }
    // },
    methods: {
        displayLoginPage: function () {
            this.$store.selectCountryPage = false;
            this.$router.push('/login');
        },
        displaySelectCountryPage: async function () {
            this.$store.selectCountryPage = true;
            this.$router.push('/selectCountry');
        }
    },
    async created() {
        // const loggedInUser = await this.$store.checkLoggedinUser();
        // // console.log(loggedInUser);
        // if (loggedInUser) {
        //     this.$router.push('/home');
        // }
    }
}
</script>

<style>
.start-page-component-container .component-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.start-page-component-container .start-page-container {
    width: 100vw;
    height: 100vh;
    min-height: 320px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 30px;
    background: #616365;
}

.start-page-component-container .fit20-logo-container {
    flex: 1;
    width: 88%;
    /* margin: -25px 0 40px; */
    display: flex;
    flex-direction: column;
    justify-content: end;
    align-items: center;
    /* justify-content: center; */
    /* border: 1px solid red; */
}

.start-page-component-container .fit20-logo-container img {
    width: 100%;
    max-width: 400px;
}

.start-page-component-container .start-page-btns-container {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.start-page-component-container .btns-wrapper {
    width: 50%;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* padding-top: 10px; */
    /* border: 1px solid red; */
}

.start-page-component-container .login-btn-container {
    flex: 2;
    width: 100%;
    max-width: 210px;
    display: flex;
    justify-content: center;
    align-items: center;
    /* padding: 15px 0; */
    /* border: 1px solid red; */
}

.start-page-component-container .login-btn {
    flex: 1;
    color: #fff;
    font-family: 'VAG Rounded Std', sans-serif;
    font-size: 30px;
    text-align: center;
    letter-spacing: 1px;
    padding: 8px 0;
    background: #009df4;
    border: 1px solid #fff;
    border-radius: 30px;
    cursor: pointer;
    /* border: 1px solid; */
}

[dir="rtl"] .start-page-component-container .login-btn {
    font-size: min(26px, calc(14px + 2vw));
    padding: 6px 0;
}

.start-page-component-container .try-free-experience-container {
    flex: 1;
    text-align: center;
    padding-bottom: 5px;
}

.start-page-component-container .try-free-experience-container p {
    font-family: 'Open Sans Std', sans-serif;

    font-size: 18px;
    color: #fff;
}

.start-page-component-container .try-free-experience-container .free-ecperience-btn {
    color: #92d400;
    font-size: 17px;
    font-weight: bold;
    letter-spacing: 1px;
    text-decoration: underline;
    cursor: pointer;
    padding-top: 2px;
    padding-bottom: 10px;
}

@media (max-width: 375px) {
    .start-page-component-container .login-btn {
        font-size: 26px;
    }
}

@media (max-width: 320px) {
    .start-page-component-container .login-btn {
        font-size: 20px;
    }

    .start-page-component-container .try-free-experience-container p {
        font-size: 14px;
    }

    .start-page-component-container .try-free-experience-container .free-ecperience-btn {
        font-size: 14px;
    }
}
</style>
